// extracted by mini-css-extract-plugin
module.exports = {"box":"InputNumber_box__TqJ_J","action":"InputNumber_action__srIx0","button":"InputNumber_button__9hx_q","number":"InputNumber_number__9o69V"};